var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenuMaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.95 14.834H18.55L21.25 21.134H3.25L5.95 14.834H9.55M13.15 8.53403C13.15 8.77273 13.0552 9.00165 12.8864 9.17043C12.7176 9.33921 12.4887 9.43403 12.25 9.43403C12.0113 9.43403 11.7824 9.33921 11.6136 9.17043C11.4448 9.00165 11.35 8.77273 11.35 8.53403C11.35 8.29534 11.4448 8.06642 11.6136 7.89764C11.7824 7.72885 12.0113 7.63403 12.25 7.63403C12.4887 7.63403 12.7176 7.72885 12.8864 7.89764C13.0552 8.06642 13.15 8.29534 13.15 8.53403ZM6.85 8.53403C6.85 13.034 12.25 17.534 12.25 17.534C12.25 17.534 17.65 13.034 17.65 8.53403C17.65 5.45873 15.2326 3.13403 12.25 3.13403C9.2674 3.13403 6.85 5.45873 6.85 8.53403Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuMaps);
export default __webpack_public_path__ + "static/media/icon_menu_maps.689574684c051d1f5578e1ee76242fd9.svg";
export { ForwardRef as ReactComponent };